import * as React from 'react';

function IconList(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.95 8.433h-9.9c-.683 0-1.237-.466-1.237-1.043s.554-1.044 1.237-1.044h9.9c.683 0 1.238.467 1.238 1.044 0 .576-.555 1.044-1.238 1.044m0 5.22h-9.9c-.683 0-1.237-.467-1.237-1.044 0-.576.554-1.044 1.237-1.044h9.9c.683 0 1.238.468 1.238 1.044 0 .577-.555 1.044-1.238 1.044z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconList = React.memo(IconList);
export default MemoIconList;
